<div class="d-flex text-center flex-column">
    <mat-icon class="material-icon align-self-center mb-5" svgIcon="group-plus"></mat-icon>
    <h1 mat-dialog-title class="t6 bold">No stock available</h1>
    <div mat-dialog-content>
        <span class="t5">No stock has been found for the requested material</span>
    </div>
    <div mat-dialog-actions class="d-flex justify-content-end pt-5">
        <button type="submit" (click)="confirm()" class="btn btn-primary btn-block col-4">Ok</button>
    </div>
</div>